<app-loading-indicator [empty]="visibleHistory.length === 0"></app-loading-indicator>
<div *ngFor="let history of visibleHistory" class="history-row {{ history.containerClass }}">
  <div *ngIf="history.showInfoRow">
    <ng-template #previewInquirerTemplate>
      @if (history.historyDescription?.inquirer?.id) {
      <app-permission-edit [permissionName]="'View Enquirer'" showFallback class="d-inline-block">
        <span
          class="medis-clickable text-14-800-dark"
          (click)="previewInquirer(history.historyDescription.inquirer.pk())"
        >
          {{ history.historyDescription.inquirer | displayInfo }}
        </span>
      </app-permission-edit>
      } @else {
      {{ 'INQUIRER' | translate }}
      }
    </ng-template>
    @if(history.category === 'fu_response' && history.createdBy?.username === 'system' &&
    !history.mergeOrDuplicateParam) {
    <ng-container *ngTemplateOutlet="previewInquirerTemplate"></ng-container>
    } @else if (history.createdBy?.id){
    <app-permission-edit [permissionName]="'View Enquiry Edited By'" class="d-inline-block">
      <span class="medis-clickable text-14-800-dark" (click)="previewUser(history.createdBy.pk())">
        {{ history.createdBy | displayInfo }}
      </span>
      <fallback-content class="text-14-800-dark">*****</fallback-content>
    </app-permission-edit>
    }
    <span *ngIf="!history.mergeOrDuplicateParam">
      @if (history.category === 'fu_response' && history.createdBy?.username != 'system') {
      {{ 'INSERTED_MANUALLY' | translate }}
      {{ history.label | lowercase }}
      {{ 'FROM' | translate }}
      <ng-container *ngTemplateOutlet="previewInquirerTemplate"></ng-container>
      {{ 'VIA' | translate }} {{ history.channel | channelTranslationKey | translate }}
      } @else {
      {{
        history.category === 'create' && !history.createdBy?.id
          ? (history.label | translate | titlecase)
          : (history.label | translate)
      }}
      <span *ngIf="history.historyDescription?.length">- {{ history.historyDescription }}</span>
      <span *ngIf="history.shouldDisplayChannel">
        {{ 'VIA' | translate }} {{ history.channel | channelTranslationKey | translate }}
      </span>
      }
    </span>
    <ng-container *ngIf="history.mergeOrDuplicateParam">
      <a [href]="resolveInteractionUrl(history.mergeOrDuplicateParam)">
        {{ history.mergeLabel | translate | lowercase }} {{ history.mergeOrDuplicateParam }}
      </a>
      <!-- The following lines below will be shown only for interaction merge. -->
      <span *ngFor="let translationKey of history.mergeReasonKeys">
        {{ translationKey | translate | lowercase }}
      </span>
    </ng-container>
    <span *ngIf="history.historyDescription?.withReopen">
      {{ 'WITH_REOPEN' | translate }}
    </span>
    <!-- Show the status change. -->
    <span *ngIf="history.historyDescription?.status?.length > 1">
      {{ 'AND_HENCE_STATUS_CHANGED_FROM' | translate }}
      <b>{{ history.historyDescription.status[0] }}</b>
      {{ 'to' | translate }}
      <b>{{ history.historyDescription.status[1] }}</b>
    </span>

    <span *ngIf="history.category === 'add_attachment' && history.text">
      {{ 'IN' | translate }} {{ history.text | translate | lowercase }}
    </span>

    {{ 'on' | translate }} {{ history.createdTs | dateChecker }}
  </div>
  <div *ngIf="history.dtlChanges" class="truncated-text medis-frame-4-azure medis-pa-5">
    <div *ngFor="let data of history.dtlChanges">
      <app-detail-history-change
        [data]="data"
        [loggedInUserIsSysAdmin]="loggedInUserIsSysAdmin"
        [history]="history"
      ></app-detail-history-change>
    </div>
  </div>
  <div
    *ngIf="history.category === 'create' && history.channel === 'email'"
    class="medis-frame-4-azure medis-pa-5 medis-flex-grow"
  >
    {{ 'From' | translate }}
    <app-permission-edit class="d-inline-block text-14-800-dark" [permissionName]="'View Enquirer'">
      <b>{{ interaction.mailFrom }}</b>
      <fallback-content>*****</fallback-content>
    </app-permission-edit>
    {{ 'To' | translate }}
    <b>{{ interaction.mailTo }}</b>
  </div>
  <div
    *ngIf="history.category === 'personal_assignment'"
    class="medis-frame-4-azure medis-pa-5 medis-flex-grow"
  >
    {{ 'From' | translate }}
    <ng-container
      *ngTemplateOutlet="previewAssignee; context: { assignee: history.reassignedFrom }"
    >
    </ng-container>
    {{ 'To' | translate }}
    <ng-container *ngTemplateOutlet="previewAssignee; context: { assignee: history.reassignedTo }">
    </ng-container>
    @if (history.text) { - {{ history.text }} }
  </div>
  <div
    *ngIf="!history.dtlChanges && !history.skipTextDisplay && history.text"
    class="medis-flex-container-even"
  >
    <div class="medis-frame-4-azure medis-pa-5 medis-flex-grow">
      @if (history.hasTranslatableText) {
      <div class="text-max-height">{{ history.text | translate }}</div>
      } @else if (history.mergeOrDuplicateParam) {
      <app-permission-edit [permissionName]="'View Enquiry Question'" showFallback>
        <div class="text-max-height" [innerHtml]="history.text | sanitizeHtml"></div>
      </app-permission-edit>
      } @else if (history.isFollowUp) {
      <app-permission-edit
        [permissionNames]="['View Enquiry Question', 'View Enquirer']"
        showFallback
      >
        <div class="text-max-height" [innerHtml]="history.text | sanitizeHtml"></div>
      </app-permission-edit>
      } @else if (['other', 'reject_answer_note'].includes(history.category)) {
      <app-permission-edit [permissionName]="'View Enquiry Answer'" showFallback>
        <div class="text-max-height" [innerHtml]="history.text | sanitizeHtml"></div>
      </app-permission-edit>
      } @else if (history.category === 'bounce_detected') {
      <app-permission-edit [permissionName]="'View Enquirer'" showFallback>
        <div class="text-max-height" [innerHtml]="history.text | sanitizeHtml"></div>
      </app-permission-edit>
      } @else {
      <div class="text-max-height" [innerHtml]="history.text | sanitizeHtml"></div>
      }
    </div>
    <app-permission-edit class="d-inline-block" [permissionName]="'View Enquiry Answer'">
      <i
        *ngIf="
          ['other', 'reject_answer_note'].includes(history.category) &&
          !interaction.isClosedOrInReview() &&
          !disabled
        "
        class="far fa-copy medis-icon"
        matTooltip="{{ 'COPY_TEXT_TO_ANSWER' | translate }}"
        (click)="copyTextToAnswer(history)"
      ></i>
    </app-permission-edit>
  </div>
  <div *ngFor="let link of history.linkedFiles">
    @if (history.text === 'ANSWER_TEXT' || ['other',
    'reject_answer_note'].includes(history.category)) {
    <app-permission-edit [permissionName]="'View Enquiry Answer'">
      <ng-container *ngTemplateOutlet="previewLink; context: { link: link, history: history }">
      </ng-container>
      <fallback-content>
        <app-link-visualization [link]="link" [noPermission]="true"></app-link-visualization>
      </fallback-content>
    </app-permission-edit>
    } @else if (history.text === 'QUESTION_TEXT' || history.mergeOrDuplicateParam || ['fu_request',
    'fu_response'].includes(history.category)) {
    <app-permission-edit [permissionName]="'View Enquiry Question'">
      <ng-container *ngTemplateOutlet="previewLink; context: { link: link, history: history }">
      </ng-container>
      <fallback-content>
        <app-link-visualization [link]="link" [noPermission]="true"></app-link-visualization>
      </fallback-content>
    </app-permission-edit>
    } @else {
    <ng-container *ngTemplateOutlet="previewLink; context: { link: link, history: history }">
    </ng-container>
    }
  </div>
</div>

<ng-template #previewAssignee let-assignee="assignee">
  <span class="text-14-800-dark">
    @if (!assignee) {
    {{ 'UNASSIGNED' | translate }}
    } @else {
    <app-permission-edit class="d-inline-block" [permissionName]="'View Enquiry Assigned To'">
      <span class="medis-clickable" (click)="previewUser(assignee.pk())">
        {{ assignee | fullName }}
      </span>
      <fallback-content>*****</fallback-content>
    </app-permission-edit>
    }
  </span>
</ng-template>

<ng-template #previewLink let-link="link" let-history="history">
  <app-link-visualization
    [link]="link"
    [allowRemove]="false"
    [canOpenFile]="loggedInUserIsSysAdmin || !link.isDeleted"
  ></app-link-visualization>
  <i
    *ngIf="
      !link.isDeleted &&
      history.category === 'other' &&
      !interaction.isClosedOrInReview() &&
      !disabled
    "
    class="far fa-copy medis-icon"
    matTooltip="{{ 'COPY_ATTACHMENT_TO_ANSWER' | translate }}"
    (click)="copyToAnswer(link)"
  ></i>
</ng-template>
